import React from "react";
import "./../../UaeAttestation/UaeBlore/UaeBlore.css";
import LithuaniaBloreMain from "./LithuaniaBloreMain";
import UaeBloreHead from "../../UaeAttestation/UaeBlore/UaeBloreHead";

const LithuaniaBlore = () => {
  return (
    <div className="uaeBloreContainer">
      <UaeBloreHead head="Lithuania Apostille in Bangalore" />
      <LithuaniaBloreMain />
    </div>
  );
};

export default LithuaniaBlore;
